import "jquery";
import "flip";

$(function(){
   $(".card").flip();
});



// WEBPACK FOOTER //
// source/javascripts/board_of_dir.js